import { useState, useEffect } from "react";
import Slider from './Slider';
import { getAllBlogs } from "../../Apis/blogs";
import "../../assets/css/admin.css";

export default function Dashboard() {
    const [stats, setStats] = useState({
        totalBlogs: 0,
        totalViews: 0,
        totalComments: 0,
        growthRate: 0
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        try {
            const response = await getAllBlogs();
            console.log('Dashboard API response:', response.data); // Debug log

            let blogs = [];
            if (response.data && response.data.success && response.data.data && response.data.data.blogs) {
                blogs = response.data.data.blogs;
            } else if (response.data && response.data.blogs) {
                blogs = response.data.blogs;
            } else if (response.data && Array.isArray(response.data)) {
                blogs = response.data;
            } else if (response.data && Array.isArray(response.data.data)) {
                blogs = response.data.data;
            }

            const totalBlogs = blogs.length;
            const totalViews = blogs.reduce((sum, blog) => sum + (blog.views || 0), 0);
            const totalComments = blogs.reduce((sum, blog) => sum + (blog.comments_count || 0), 0);
            const growthRate = totalBlogs > 0 ? Math.round((blogs.filter(blog =>
                new Date(blog.created_at) > new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
            ).length / totalBlogs) * 100) : 0;

            setStats({
                totalBlogs,
                totalViews,
                totalComments,
                growthRate
            });
        } catch (error) {
            console.error('Error fetching stats:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-dashboard">
            <Slider />
            {/* Main Content */}
            <div className="admin-main-content">
                {/* Breadcrumb */}
                <div className="admin-breadcrumb">
                    <div className="admin-breadcrumb-text">Admin / Dashboard</div>
                </div>

                {/* Main Content Area */}
                <div className="admin-content-area">
                    <h1 className="admin-welcome-title">Welcome to Ridge Crest Admin</h1>

                    {/* Stats Cards */}
                    <div className="admin-stats-grid">
                        <div className="admin-stat-card">
                            <div className="admin-stat-icon admin-stat-icon-blue">
                                📝
                            </div>
                            <div className="admin-stat-content">
                                <div className="admin-stat-number">{loading ? '...' : stats.totalBlogs}</div>
                                <div className="admin-stat-label">Total Blogs</div>
                            </div>
                        </div>

                        <div className="admin-stat-card">
                            <div className="admin-stat-icon admin-stat-icon-green">
                                👁️
                            </div>
                            <div className="admin-stat-content">
                                <div className="admin-stat-number">{loading ? '...' : stats.totalViews.toLocaleString()}</div>
                                <div className="admin-stat-label">Total Views</div>
                            </div>
                        </div>

                        <div className="admin-stat-card">
                            <div className="admin-stat-icon admin-stat-icon-purple">
                                💬
                            </div>
                            <div className="admin-stat-content">
                                <div className="admin-stat-number">{loading ? '...' : stats.totalComments}</div>
                                <div className="admin-stat-label">Comments</div>
                            </div>
                        </div>

                        <div className="admin-stat-card">
                            <div className="admin-stat-icon admin-stat-icon-orange">
                                📈
                            </div>
                            <div className="admin-stat-content">
                                <div className="admin-stat-number">{loading ? '...' : `${stats.growthRate}%`}</div>
                                <div className="admin-stat-label">Growth Rate</div>
                            </div>
                        </div>
                    </div>

                    {/* Recent Activity */}
                    <div className="admin-section">
                        <h2 className="admin-section-title">Recent Activity</h2>
                        <div className="admin-activity-list">
                            <div className="admin-activity-item">
                                <div className="admin-activity-icon">📝</div>
                                <div className="admin-activity-content">
                                    <div className="admin-activity-title">New blog created</div>
                                    <div className="admin-activity-time">2 hours ago</div>
                                </div>
                            </div>
                            <div className="admin-activity-item">
                                <div className="admin-activity-icon">✏️</div>
                                <div className="admin-activity-content">
                                    <div className="admin-activity-title">Blog updated</div>
                                    <div className="admin-activity-time">5 hours ago</div>
                                </div>
                            </div>
                            <div className="admin-activity-item">
                                <div className="admin-activity-icon">🗑️</div>
                                <div className="admin-activity-content">
                                    <div className="admin-activity-title">Blog deleted</div>
                                    <div className="admin-activity-time">1 day ago</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}